import React, { useState } from "react";
import styles from "./TabItem.module.css";
import PropTypes from "prop-types";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Divider from "@material-ui/core/Divider";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

function TabItem(props) {
  const { item } = props;
  const { name, categories } = item;

  const [anchorEl, setAnchorEl] = useState(null);
  const [openKeyBoard, setOpenKeyBoard] = useState(false);

  const handleClick = (event) => {
    setOpenKeyBoard(!openKeyBoard);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenKeyBoard(!openKeyBoard);
  };

  const handleClickMenuItem = (idCategory) => {
    setAnchorEl(null);
    setOpenKeyBoard(!openKeyBoard);

    history.push(`${RouterName.Products.category.url}/${idCategory}`);
  };

  return (
    <span className={styles.container}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        color="primary"
        size="large"
        endIcon={
          name == "home" ? null : openKeyBoard ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )
        }
        className={styles.btn_menu}
      >
        {name}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={styles.menu_container}
      >
        {categories.map((item, index) => {
          return (
            <span key={index}>
              <MenuItem
                onClick={() => handleClickMenuItem(item.id)}
                className={styles.menu_item}
              >
                <ArrowRightIcon fontSize="small" />
                {item.name}
              </MenuItem>
              <Divider component="li" />
            </span>
          );
        })}
      </Menu>
    </span>
  );
}

TabItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TabItem;
